import gql from 'graphql-tag';

export default gql`
  mutation removeSuggestion($suggestionsListId: ID!, $suggestionId: ID!) {
    removeSuggestion(
      suggestionsListId: $suggestionsListId
      suggestionId: $suggestionId
    )
  }
`;
